import React, { Component } from "react";

import { withFirebase } from "../Firebase";

class SignOut extends Component {
  render() {
    this.props.firebase.doSignOut();
    return (
      <div>
        <h1>Thank you using the system. You are now logged out!</h1>
      </div>
    );
  }
}

export default withFirebase(SignOut);
